(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-row.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const {
  useSelector
} = ReactRedux;
const {
  HelpDialog,
  EventParticipantDistributions,
  EventParticipantOutcome
} = svs.components.tipsen.couponScore;
const {
  Coupon
} = svs.components.tipsen.couponComponents;
const {
  constants: engineConstants
} = svs.components.tipsen.engine;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  useContext
} = React;
const {
  TipsenLink
} = svs.components.tipsen.tipsen_link;
const {
  getEventLink
} = svs.components.tipsen.tipsen_link.utils;
const {
  useDrawSearchParams
} = svs.components.tipsen.drawProvider.hooks;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const {
  selectParticipant
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useBetEvent
} = svs.components.sportinfo.matchInfoHooks;
const {
  useIsTipsinfoEnabled
} = svs.components.tipsen.hooks;
const {
  selectShowMatchAnalyseText
} = svs.components.tipsen.selectors;
const {
  CouponRowHeader,
  CouponRowBody,
  CouponRowFooter
} = svs.components.tipsen.couponScore.couponRowSections;
const {
  RenderContext
} = svs.component.tipsen.renderContext;
const {
  TipsinfoRow,
  TipsinfoRowText
} = svs.components.tipsen.tipsinfo;
const {
  selectSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const transformDistributionsByParticipant = distributions => {
  if (!Array.isArray(distributions)) {
    return [[], []];
  }
  const homeDistributions = distributions.map(subArray => subArray === null || subArray === void 0 ? void 0 : subArray[0]);
  const awayDistributions = distributions.map(subArray => subArray === null || subArray === void 0 ? void 0 : subArray[1]);
  return [homeDistributions, awayDistributions];
};
const LabelMap = {
  [engineConstants.ReductionScore.HOME]: 'Hemma',
  [engineConstants.ReductionScore.DRAW]: 'Oavgjort',
  [engineConstants.ReductionScore.AWAY]: 'Borta'
};
const CouponRow = _ref => {
  var _useSelector, _useSelector2, _eventStatistics$dist;
  let {
    drawNumber = 0,
    eventNumber = 0,
    productId = 0,
    sportType = 0
  } = _ref;
  const {
    pageType
  } = useContext(RenderContext);
  const {
    isSvenskaFolketEnabled,
    isSvenskaFolketAsOutcomesEnabled,
    isBetPredictionEnabled,
    isMatchStartEnabled
  } = useIsTipsinfoEnabled();
  const {
    betEvent,
    eventStatistics
  } = useBetEvent({
    productId,
    drawNumber,
    eventNumber
  });
  const {
    eventComment,
    matchId,
    participants,
    periodNumber
  } = betEvent;
  const {
    eventNumber: selectedEventNumber
  } = useContext(DrawContext);
  const toParams = useDrawSearchParams(productId, drawNumber, eventNumber);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const homeTeamName = (_useSelector = useSelector(state => selectParticipant(state, participants[0]))) === null || _useSelector === void 0 ? void 0 : _useSelector.name;
  const awayTeamName = (_useSelector2 = useSelector(state => selectParticipant(state, participants[1]))) === null || _useSelector2 === void 0 ? void 0 : _useSelector2.name;
  const isAriaSelected = showCouponAndDetailView && eventNumber === selectedEventNumber;
  const distributions = isSvenskaFolketEnabled || isSvenskaFolketAsOutcomesEnabled ? (eventStatistics === null || eventStatistics === void 0 || (_eventStatistics$dist = eventStatistics.distributions) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist[productId]) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist[drawNumber]) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist.current) === null || _eventStatistics$dist === void 0 ? void 0 : _eventStatistics$dist.value) || [] : [];
  const distributionsByParticipant = transformDistributionsByParticipant(distributions);
  const shouldShowDistributionsComponent = !isSmallDevice && !isSvenskaFolketAsOutcomesEnabled && distributions.length > 0;
  const showBetPredictionsInCoupon = isBetPredictionEnabled && !periodNumber;
  const isAnalysisSelected = useSelector(state => selectShowMatchAnalyseText(state, pageType));
  const showMatchAnalysesInCoupon = !periodNumber && isAnalysisSelected;
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const shouldDisplayMatchstart = isMatchStartEnabled;

  return React.createElement("div", _extends({
    className: "pg_coupon_row",
    key: eventNumber
  }, isAriaSelected ? {
    'aria-selected': true
  } : {}), React.createElement(TipsenLink, {
    className: "pg_coupon_row_link",
    to: {
      pathname: getEventLink(),
      search: "?".concat(searchParams)
    }
  }, React.createElement("span", {
    className: "sr-only"
  }, "".concat(homeTeamName, " vs. ").concat(awayTeamName))), periodNumber && React.createElement(CouponRowHeader, {
    className: "pg_coupon_row__period"
  }, "Period ".concat(periodNumber)), React.createElement(CouponRowBody, null, React.createElement("div", {
    className: "pg_coupon_row__event"
  }, [0, 1].map(eventGroupIndex => React.createElement("div", {
    className: "pg_coupon_row__event__participant",
    key: eventGroupIndex
  }, React.createElement("div", {
    className: "pg_coupon_row__event__participant__name"
  }, eventGroupIndex === 0 ? homeTeamName : awayTeamName), React.createElement(EventParticipantOutcome, {
    distributions: distributionsByParticipant[eventGroupIndex],
    eventNumber: eventNumber,
    outcomeGroupIndex: eventGroupIndex,
    participants: participants,
    productId: productId,
    sportType: sportType
  }), shouldShowDistributionsComponent && React.createElement(EventParticipantDistributions, {
    distributions: distributionsByParticipant[eventGroupIndex],
    drawId: "".concat(productId, "_").concat(drawNumber)
  })))), shouldDisplayMatchstart && sportEvent.matchStart && React.createElement(TipsinfoRow, {
    className: "pg_coupon_row__match_start",
    date: sportEvent.matchStart,
    title: "Matchstart:"
  }, React.createElement(TipsinfoRowText, {
    className: "pg_coupon_row__match_start__date"
  }, svs.components.lbUtils.helpers.formatDate.formatDate(sportEvent.matchStart, true, true, true))), eventComment && React.createElement("div", {
    className: "pg_coupon_row__web_text"
  }, React.createElement(Coupon.WebText, {
    eventComment: eventComment
  })), (showBetPredictionsInCoupon || showMatchAnalysesInCoupon) && React.createElement("div", {
    className: "pg_coupon_row__analysis_section"
  }, showBetPredictionsInCoupon && React.createElement("div", {
    className: "pg_coupon_row__bet_predictions"
  }, React.createElement(Coupon.BetPrediction, {
    drawNumber: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })), showMatchAnalysesInCoupon && React.createElement("div", {
    className: "pg_coupon_row__analyzes"
  }, React.createElement(Coupon.GameAnalysis, {
    drawNumber: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })))), React.createElement(CouponRowFooter, null, React.createElement("div", {
    className: "pg_coupon_row__reductions"
  }, React.createElement("div", {
    className: "pg_coupon_row__reductions__text"
  }, "Reducera bort resultat", React.createElement(HelpDialog, null)), React.createElement("div", {
    className: "pg_coupon_row__reductions__labels"
  }, React.createElement(Coupon.Reductions, {
    eventNumber: eventNumber,
    labelMap: LabelMap
  })))));
};
setGlobal('svs.components.tipsen.couponScore.CouponRow', CouponRow);

 })(window);